import * as _4 from 'lodash4';
import { StrategySafe } from 'utility-ts-strategy';

type UnreadTypes = 'THREAD' | 'CONVERSATION';

interface IConversationPriorityFeedStrategy {
  title: (count: number) => string;
  subTitle: string;
  state: string;
  params: {
    filter?: string;
  };
}

export const ConversationPriorityFeedStrategy = new StrategySafe<IConversationPriorityFeedStrategy, UnreadTypes>({
  THREAD: {
    title: (count: number) => 'You have an unread notification',
    subTitle: 'Check it out',
    state: 'my.conversations',
    params: {
      filter: 'unread'
    }
  },
  CONVERSATION: {
    title: (count: number) => `You have ${count} unread notifications`,
    subTitle: 'Check them out',
    state: 'my.conversations',
    params: {
      filter: 'unread'
    }
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/strategies/conversation_priority_feed_strategy.ts